<script lang="ts">
  import { client } from '$lib/api/Client';
  import Modal from './Modal.svelte';
  import SlideOver from './SlideOver.svelte';
  import WelcomeModalContent from './WelcomeModalContent.svelte';

  let agreedToTerms = false;
  let showWelcomeModal = true;

  const handleSubmitModal = async () => {
    await client.users.agreeToTerms();
    showWelcomeModal = false;
    window.location.href = '/';
  };
</script>

<SlideOver
  title="GM and Welcome! 🏟️"
  clickoutCloseDisabled={true}
  allowExit={false}
  bind:slideOverOpen={showWelcomeModal}
  class="md:hidden"
>
  <WelcomeModalContent bind:agreedToTerms onSubmit={handleSubmitModal} />
</SlideOver>

<Modal
  title="GM and Welcome! 🏟️"
  clickoutCloseDisabled={true}
  allowExit={false}
  allowScroll={true}
  size={'lg'}
  bind:modalOpen={showWelcomeModal}
  class="hidden md:block"
>
  <WelcomeModalContent bind:agreedToTerms onSubmit={handleSubmitModal} />
</Modal>
